/* import __COLOCATED_TEMPLATE__ from './icon-triple-dot.hbs'; */
import SvgIcon from './svg-icon';
export default SvgIcon.extend({
  classNames: ['svg-icon--triple-dot'],
  attributeBindings: ['titleId:aria-labelledby'],
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  // Passed in
  titleId: null
});